// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fedaa1f5","455":"659edf4b"}[chunkId] + ".chunk.js";
};